<!-- 精品项目-详情页面 -->
<template>
  <div>
    <span id="spanData">
      <el-card class="box-card">
        <!-- 使用table标签布局 -->
        <table>
          <!-- 设置标题 -->
          <tr>
            <th colspan="2">
              <h1 id="h1Title">{{ resProjectData.title }}</h1>
            </th>
          </tr>
          <!-- 设置标题信息 -->
          <tr>
            <th colspan="2">
              <el-tag id="tag1" type="info">
                <!-- 用户名 -->
                <span style="color: black; font-size: small">
                  {{
                    resProjectData.userData.nickName != null
                      ? resProjectData.userData.nickName
                      : resProjectData.userData.userName
                  }}
                </span>
                <!-- 创建时间 -->
                <span style="margin-left: 20px">
                  <i class="el-icon-time"></i>
                  于&nbsp;&nbsp;{{
                    resProjectData.createtime
                  }}&nbsp;&nbsp;创建 </span
                ><br />
                <!-- 项目类型 -->
                <span>
                  项目类型:
                  <el-tag size="mini" style="margin-left: 10px">
                    {{ resProjectData.strProjectType }}
                  </el-tag>
                </span>
              </el-tag>
            </th>
          </tr>

          <!-- 设置内容 -->
          <tr>
            <td colspan="2">
              <el-card shadow="always">
                <div v-html="resProjectData.content"></div>
              </el-card>
            </td>
          </tr>

          <!-- 立即兑换 -->
          <tr>
            <td colspan="2" style="text-align: center">
              <!-- 判断角色，若为 admin 显示下载按钮，否则显示兑换按钮 -->
              <el-button
                v-if="resProjectData.userData.roleType === 'admin'"
                type="success"
                plain
                @click="downLoad()"
                >下载</el-button
              >
              <el-button v-else type="success" plain @click="conversion()"
                >兑换</el-button
              >
            </td>
          </tr>
        </table>
      </el-card>
    </span>
  </div>
</template>
     
    
    <script>
// 导入需要的js文件
import {
  queryProjectById,
  findConversion,
  findProjectAccessRecords,
  downLoadFile,
} from "@/api/appProject/delicacyProject.js";
export default {
  data() {
    return {
      resProjectData: {}, //响应回来的内容数据
      resData: {}, //点击兑换-确定-请求参数
      recordData: {}, //当前用户是否拥有当前项目请求参数
      isAdmin:"" //是否是管理员标识
    };
  },

  //   一进入页面执行
  created() {
    // 获取内容信息
    this.gainDetails();
  },
  computed: {
    // 获取传递过来的bankId
    getProjectId() {
      return this.$route.params.projectId;
    },
  },

  methods: {
    // 获取当前登录用户
    getUserId() {
      const userData = JSON.parse(localStorage.getItem("accessUserData"));
      this.resData.userId = userData.data.userId;
      this.recordData.userId = userData.data.userId;
      this.isAdmin=userData.data.roleType;//是否是管理员标识
    },

    // 获取内容信息
    async gainDetails() {
      // 获取传递过来的值
      console.log("获取传递过来的值：" + this.getProjectId);
      // 调用接口，看当前用户是否已经拥有当前项目
      this.recordData.projectId = this.getProjectId;
      this.getUserId(); //设置当前登录用户id
      const recordRes = await findProjectAccessRecords(this.recordData);

      // 调用查询接口获取内容数据
      const res = await queryProjectById(this.getProjectId);
      const f1 = recordRes.data; //必须有值
      const f2 = res.data.userData.roleType; //值是admin
      // 判断当前登录用户是否是管理员，如果是，则可以直接下载
      if ((f1 != null && f1 != 0) || this.isAdmin === "admin") {
        res.data.userData.roleType = "admin";
      }else{
        res.data.userData.roleType = "common";
      }
      console.log("是否是管理员："+this.isAdmin+f1);


      // 获取响应数据进行赋值
      this.resProjectData = res.data;
    },

    // 点击兑换后，进行弹框
    conversion() {
      this.$prompt("请输入兑换码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          // 这里的 value 是用户输入的兑换码
          // 拼接请求参数
          this.resData.cdkey = value; //兑换码
          this.resData.projectId = this.getProjectId; //项目id
          this.getUserId(); //设置当前登录用户id
          // 调用方法，处理兑换码
          this.handleExchangeCode();
        })
        .catch(() => {
          // 点击取消时的处理（可选）
          // console.log("用户取消了");
        });
    },

    // 兑换码弹框后，点击确定，处理兑换码
    async handleExchangeCode() {
      const res = await findConversion(this.resData);
      if (res.status === "200") {
        this.resProjectData.userData.roleType = "admin";
      }
    },

    // 点击下载后调用该方法
    async downLoad() {
      const res = await downLoadFile(this.getProjectId);
      const fileUrl=res.data;
      // 创建一个隐藏的 <a> 标签
      const a = document.createElement("a");
      a.href = fileUrl;
      a.download = fileUrl.split("/").pop(); // 使用文件名作为下载名称，或者根据需要自定义

      // 触发点击事件下载文件
      a.click();
    },
  },
};
</script>
  
    <style scoped>
/* 设置标题内容样式 */
#tag1 {
  width: 100%;
  height: auto;
}

/* 标题样式 */
#h1Title {
  text-align: center;
}

/* 布局table样式 */
table {
  width: 100%;
  border-collapse: collapse;
}
th,
td {
  /* border: 1px solid #000; */
  padding: 8px;
  text-align: left;
}

/* 外围span标签样式 */
#spanData {
  display: flex;
  justify-content: center;
}
/* 外围card样式 */
.box-card {
  width: 70%;
}
</style>